import React, {useCallback, useEffect, useRef} from "react"
import {option} from "./chart-option";
import EChartsReact from "echarts-for-react";
import styled from "styled-components";
import {useVipInfo} from "../../context/VipInfoContext";
export default function PriceChart() {
    const ref = useRef(null)
    const {soldRegisterCount} = useVipInfo()
    const updateCurrent = useCallback((value) => {
        const x = Math.floor((value - 1) / 100)
        const y = x * 2 + 10
        option.series[0].markPoint.data = [{value, xAxis: x, yAxis: y}]
        //@ts-ignore
        ref.current.getEchartsInstance().setOption(option)
    }, [ref])
    useEffect(() => {
        updateCurrent(soldRegisterCount)
    }, [soldRegisterCount, updateCurrent])
    return <ChartWrapper>
        <Tips className={"top"}>Price per Member</Tips>
        <Tips className={"bottom"}>Memberships Sold</Tips>
        <EChartsReact ref={ref} style={{width: 580, height: 400}} option={option}/>
    </ChartWrapper>
}

const ChartWrapper = styled.div`
  width: 560px;
  height: 400px;
  position: relative;
`

const Tips = styled.span`
  font-size: 14px;
  color: #74A0FF;
  line-height: 19px;
  position: absolute;
  &.top {
    top: 20px;
    left: 50px;
  }
  &.bottom {
    right: 0;
    bottom: 10px;
  }
`